module.exports = __webpack_public_path__ + "img/commande fournisseur.d019a655.png";